<template>
  <div class="flex items-top space-x-4 my-2" :class="{ 'pt-4 mt-4 border-brand-sand border-t': !standalone }">
    <font-awesome-layers class="text-2xl" v-if="completed">
      <font-awesome-icon :icon="['fas', 'circle']" class="text-green-200" />
      <font-awesome-icon :icon="['fas', 'check']" class="text-green-800 opacity-50 text-sm" />
    </font-awesome-layers>
    <font-awesome-icon :icon="['fas', 'times-circle']" class="text-brand-medium-brown text-2xl" v-else />
    <span class="text-brand-medium-brown text-md font-semibold">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    completed: {
      type: Boolean,
    },
    standalone: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
